import React from 'react';

const AIIcon = ({ className = '' }) => {
  return (
    <svg
      width="24"
      height="23"
      viewBox="0 0 24 23"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        d="M12 1.5L13.09 7.76L20 8.5L13.09 9.24L12 15.5L10.91 9.24L4 8.5L10.91 7.76L12 1.5Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M19 14.5L19.5 16.5L22 17L19.5 17.5L19 19.5L18.5 17.5L16 17L18.5 16.5L19 14.5Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M5 14.5L5.5 16.5L8 17L5.5 17.5L5 19.5L4.5 17.5L2 17L4.5 16.5L5 14.5Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default AIIcon;
